/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CarrierEmail,
  CarrierEmailSummary,
  DocumentDownloadResponse,
  LogCarrierEmailRequest,
  LogEmailResult,
  OutlookMessage,
  OutlookMessageSummary,
  PreviewCarrierEmailRequest,
} from "../models/index";
import {
  CarrierEmailFromJSON,
  CarrierEmailToJSON,
  CarrierEmailSummaryFromJSON,
  CarrierEmailSummaryToJSON,
  DocumentDownloadResponseFromJSON,
  DocumentDownloadResponseToJSON,
  LogCarrierEmailRequestFromJSON,
  LogCarrierEmailRequestToJSON,
  LogEmailResultFromJSON,
  LogEmailResultToJSON,
  OutlookMessageFromJSON,
  OutlookMessageToJSON,
  OutlookMessageSummaryFromJSON,
  OutlookMessageSummaryToJSON,
  PreviewCarrierEmailRequestFromJSON,
  PreviewCarrierEmailRequestToJSON,
} from "../models/index";

export interface DownloadAttachmentRequest {
  carrierEmailId: string;
  index: number;
}

export interface GetEmailRequest {
  carrierEmailId: string;
}

export interface ListEmailsForCarrierRequest {
  carrierIdentifier: string;
}

export interface LogEmailRequest {
  logCarrierEmailRequest: LogCarrierEmailRequest;
}

export interface PreviewEmailRequest {
  previewCarrierEmailRequest: PreviewCarrierEmailRequest;
}

export interface RecentMessagesRequest {
  carrierIdentifier: string;
  search: string;
  showAll?: boolean;
}

/**
 *
 */
export class CarrierEmailsApi extends runtime.BaseAPI {
  /**
   */
  async downloadAttachmentRaw(
    requestParameters: DownloadAttachmentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DocumentDownloadResponse>> {
    if (requestParameters["carrierEmailId"] == null) {
      throw new runtime.RequiredError(
        "carrierEmailId",
        'Required parameter "carrierEmailId" was null or undefined when calling downloadAttachment().',
      );
    }

    if (requestParameters["index"] == null) {
      throw new runtime.RequiredError(
        "index",
        'Required parameter "index" was null or undefined when calling downloadAttachment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-emails/{carrierEmailId}/attachments/{index}`
          .replace(
            `{${"carrierEmailId"}}`,
            encodeURIComponent(String(requestParameters["carrierEmailId"])),
          )
          .replace(
            `{${"index"}}`,
            encodeURIComponent(String(requestParameters["index"])),
          ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DocumentDownloadResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async downloadAttachment(
    requestParameters: DownloadAttachmentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DocumentDownloadResponse> {
    const response = await this.downloadAttachmentRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getEmailRaw(
    requestParameters: GetEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CarrierEmail>> {
    if (requestParameters["carrierEmailId"] == null) {
      throw new runtime.RequiredError(
        "carrierEmailId",
        'Required parameter "carrierEmailId" was null or undefined when calling getEmail().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-emails/{carrierEmailId}`.replace(
          `{${"carrierEmailId"}}`,
          encodeURIComponent(String(requestParameters["carrierEmailId"])),
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CarrierEmailFromJSON(jsonValue),
    );
  }

  /**
   */
  async getEmail(
    requestParameters: GetEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CarrierEmail> {
    const response = await this.getEmailRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async listEmailsForCarrierRaw(
    requestParameters: ListEmailsForCarrierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierEmailSummary>>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling listEmailsForCarrier().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-emails/for-carrier`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierEmailSummaryFromJSON),
    );
  }

  /**
   */
  async listEmailsForCarrier(
    requestParameters: ListEmailsForCarrierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierEmailSummary>> {
    const response = await this.listEmailsForCarrierRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Snapshot the conversation (whole thread by default) onto the carrier and copy attachments.
   * Snapshot the conversation (whole thread by default) onto the carrier and copy attachments.
   */
  async logEmailRaw(
    requestParameters: LogEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LogEmailResult>> {
    if (requestParameters["logCarrierEmailRequest"] == null) {
      throw new runtime.RequiredError(
        "logCarrierEmailRequest",
        'Required parameter "logCarrierEmailRequest" was null or undefined when calling logEmail().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-emails/log`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: LogCarrierEmailRequestToJSON(
          requestParameters["logCarrierEmailRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LogEmailResultFromJSON(jsonValue),
    );
  }

  /**
   * Snapshot the conversation (whole thread by default) onto the carrier and copy attachments.
   * Snapshot the conversation (whole thread by default) onto the carrier and copy attachments.
   */
  async logEmail(
    requestParameters: LogEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LogEmailResult> {
    const response = await this.logEmailRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Fetch one of the operator\'s messages in full for review. Does not persist.
   * Fetch one of the operator\'s messages in full for review.
   */
  async previewEmailRaw(
    requestParameters: PreviewEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OutlookMessage>> {
    if (requestParameters["previewCarrierEmailRequest"] == null) {
      throw new runtime.RequiredError(
        "previewCarrierEmailRequest",
        'Required parameter "previewCarrierEmailRequest" was null or undefined when calling previewEmail().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-emails/preview`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PreviewCarrierEmailRequestToJSON(
          requestParameters["previewCarrierEmailRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OutlookMessageFromJSON(jsonValue),
    );
  }

  /**
   * Fetch one of the operator\'s messages in full for review. Does not persist.
   * Fetch one of the operator\'s messages in full for review.
   */
  async previewEmail(
    requestParameters: PreviewEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OutlookMessage> {
    const response = await this.previewEmailRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * The current operator\'s recent Outlook messages for the picker. Defaults to the carrier\'s email domains; pass \\[showAll\\]=true to drop the filter, or \\[search\\] to free-text search.
   * The current operator\'s recent Outlook messages for the picker.
   */
  async recentMessagesRaw(
    requestParameters: RecentMessagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<OutlookMessageSummary>>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling recentMessages().',
      );
    }

    if (requestParameters["search"] == null) {
      throw new runtime.RequiredError(
        "search",
        'Required parameter "search" was null or undefined when calling recentMessages().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    if (requestParameters["search"] != null) {
      queryParameters["search"] = requestParameters["search"];
    }

    if (requestParameters["showAll"] != null) {
      queryParameters["showAll"] = requestParameters["showAll"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-emails/recent`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(OutlookMessageSummaryFromJSON),
    );
  }

  /**
   * The current operator\'s recent Outlook messages for the picker. Defaults to the carrier\'s email domains; pass \\[showAll\\]=true to drop the filter, or \\[search\\] to free-text search.
   * The current operator\'s recent Outlook messages for the picker.
   */
  async recentMessages(
    requestParameters: RecentMessagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<OutlookMessageSummary>> {
    const response = await this.recentMessagesRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
